export async function useSmoxyForWorkSubscribe(email: string, firstName: string|undefined, lastName: string|undefined): Promise<any> {
  return await $fetch('https://us-central1-smoxy-app.cloudfunctions.net/api/mailchimp/subscribe', {
    method: 'POST',
    params: { 'email': email, 'firstName': firstName, 'lastName': lastName },
  }).catch(e => e.data);
}